import {useContext} from "react";
import MessageAlerts from "../MessagesAlerts";
import "./index.css"
import AuthContext from "../../../../contexts/auth";
import CurrentBalanceStats from "./CurrentBalance";
import SummaryRemmitancesStats from "./SummaryRemmitances";
import WithDrawnYearStats from "./WithDrawnYear";

const DashboardStats = () => {
  const UserContext = useContext(AuthContext);

  const getName = () => {
    if (UserContext.user.NombreSimple.indexOf(" ")) {
      return UserContext.user.NombreSimple.split(" ")[0];
    } else {
      return UserContext.user.NombreSimple;
    }
  };

  const greetings = () => {
    const hour = new Date().getHours();
    if (hour >= 0 && hour < 12) {
      return "Buenos días, ";
    } else if (hour >= 12 && hour < 19) {
      return "Buenas tardes, ";
    } else if (hour >= 19) {
      return "Buenas noches, ";
    }
  };

  return (
    <>
     <div
  className="dashboardCard text-left mb-2 d-flex flex-column flex-md-row justify-content-between align-items-center"
  style={{
    color: "black",
  }}
>
  <div>
    <h4 className="m-0">
      {greetings() + (UserContext.user ? getName() : "Usuario")}!
    </h4>
    <p className="m-0">
      Bienvenido a nuestro sistema de giros.{" "}
    </p>
  </div>
    <CurrentBalanceStats />
</div>

  <SummaryRemmitancesStats />

     <div className="row mx-2">
        <div className="col-12 col-md-6 p-2">
          <WithDrawnYearStats />
        </div>
        <div className="col-12 col-md-6 p-2">
           <MessageAlerts />
        </div>
      </div>
    </>
  );
};

export default DashboardStats;
